import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;

async function tryRefresh() {
  if (!refreshing) {
    refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
  }
  return refreshing;
}

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config || {};
    const url = cfg.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (err?.response?.status === 401 && !isAuthCall && !cfg._retried) {
      cfg._retried = true;
      try {
        await tryRefresh();
        return api(cfg);
      } catch {
        if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
